module.exports = __webpack_public_path__ + "img/bennet-memorial.b1047424.jpg";